// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".select-count {\n\tfont-weight: bold;\n\tfont-size: 12px;\n\tline-height: 24px;\n\twhite-space: nowrap;\n}\n", "",{"version":3,"sources":["SelectCount.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,eAAe;CACf,iBAAiB;CACjB,mBAAmB;AACpB","file":"SelectCount.css","sourcesContent":[".select-count {\n\tfont-weight: bold;\n\tfont-size: 12px;\n\tline-height: 24px;\n\twhite-space: nowrap;\n}\n"]}]);
// Exports
module.exports = exports;
